import axios, { AxiosRequestConfig } from 'axios';

import { apiInterceptors } from '@/utils/report';

export default function createRequest(config: AxiosRequestConfig & { report?: boolean } & { isBypass?: boolean }) {
  const { report = true, ...axiosConfig } = config;
  const instance = axios.create({
    baseURL: '/api/v1/',
    withCredentials: true,
    timeout: 60000, // 60s
    ...axiosConfig,
  });

  if (report) {
    instance?.interceptors?.response?.use?.(
      (response) => {
        apiInterceptors(response);
        return response;
      },
      err => {
        apiInterceptors(err);
        return Promise.reject(err);
      },
    );
  }
  return instance;
}
